module.exports = "<div style=\"height: calc(100% - 40px - 71.6px)\">\n    <div class=\"row text-center\">\n        <span>You can download your Files from following link</span>\n    </div>\n    <div class=\"row text-center\">\n        <a href=\"{{fileUrl}}\">Download</a>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/content/ispring/ispring.component.html
// module id = 879
// module chunks = 0